import { render, staticRenderFns } from "./VersionNote.vue?vue&type=template&id=3113f237"
import script from "./VersionNote.vue?vue&type=script&lang=js"
export * from "./VersionNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports